import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Offcanvas, Button } from 'react-bootstrap';
import {
  FiMenu,
  FiUser,
  FiHome,
  FiLogOut,
  FiFileText,
  FiDollarSign,
} from 'react-icons/fi';
import '../../styles/sidebar.css';

const SidebarCajero = ({ slug }) => {
  const [show, setShow] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  let user = {};
  let business = {};

  try {
    user = JSON.parse(localStorage.getItem('user')) || {};
    business = JSON.parse(localStorage.getItem('business')) || {};
  } catch (e) {
    console.warn('Error al parsear datos del storage');
  }

  const logout = () => {
    localStorage.clear();
    navigate('/login');
  };

  const navItems = [
    { to: `/cajero/${slug}/dashboard`, label: 'Dashboard', icon: <FiHome /> },
    { to: `/cajero/${slug}/pedidos`, label: 'Pedidos', icon: <FiFileText /> },
    { to: `/cajero/${slug}/cobrar`, label: 'Cobrar mesas', icon: <FiDollarSign /> },
    { to: `/cajero/${slug}/turno`, label: 'Turno', icon: <FiDollarSign /> },
  ];

  const SidebarContent = () => (
    <div className="sidebar-content p-3">
      <h2>{business.name || 'MesaApp'}</h2>
      <p className="user-info"><FiUser /> {user.name || 'Cajero'}</p>
      <nav>
        <ul className="sidebar-nav">
          {navItems.map(({ to, label, icon }) => (
            <li key={to}>
              <Link
                to={to}
                className={location.pathname === to ? 'active-link' : ''}
                onClick={() => setShow(false)}
              >
                {icon} {label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
      <button onClick={logout}><FiLogOut /> Cerrar sesión</button>
    </div>
  );

  return (
    <>
      {/* 🖥️ Sidebar fijo en desktop */}
      <div className="sidebar-fixed d-none d-md-flex">
        <SidebarContent />
      </div>

      {/* 📱 Navbar + botón hamburguesa en mobile */}
      <div className="navbar-top d-flex d-md-none">
        <Button variant="outline-secondary" onClick={() => setShow(true)}>
          <FiMenu />
        </Button>
        <span className="navbar-title">{business.name || 'MesaApp'}</span>
      </div>

      <Offcanvas show={show} onHide={() => setShow(false)} placement="start" style={{ width: '260px' }}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Menú</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <SidebarContent />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default SidebarCajero;
